import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with interceptor for auth
const apiClient = axios.create({
  baseURL: API
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth APIs
export const authAPI = {
  login: (email, password) => apiClient.post('/auth/login', { email, password }),
  register: (email, password, name) => apiClient.post('/auth/register', { email, password, name }),
  getCurrentUser: () => apiClient.get('/auth/me')
};

// Contact APIs
export const contactAPI = {
  submit: (data) => axios.post(`${API}/contact`, data),
  getAll: () => apiClient.get('/admin/contacts'),
  download: () => apiClient.get('/admin/contacts/download', { responseType: 'blob' }),
  delete: (id) => apiClient.delete(`/admin/contacts/${id}`)
};

// Newsletter APIs
export const newsletterAPI = {
  subscribe: (email) => axios.post(`${API}/newsletter/subscribe`, { email }),
  getAll: () => apiClient.get('/admin/newsletters'),
  download: () => apiClient.get('/admin/newsletters/download', { responseType: 'blob' })
};

// Blog APIs
export const blogAPI = {
  getPublished: (skip = 0, limit = 10, category = null) => {
    let url = `/blog?skip=${skip}&limit=${limit}`;
    if (category) url += `&category=${category}`;
    return axios.get(`${API}${url}`);
  },
  getBySlug: (slug) => axios.get(`${API}/blog/${slug}`),
  getAll: () => apiClient.get('/admin/blog'),
  create: (data) => apiClient.post('/admin/blog', data),
  update: (id, data) => apiClient.put(`/admin/blog/${id}`, data),
  delete: (id) => apiClient.delete(`/admin/blog/${id}`)
};

// Settings APIs
export const settingsAPI = {
  get: () => axios.get(`${API}/settings`),
  update: (data) => apiClient.put('/admin/settings', data)
};

// Projects APIs
export const projectsAPI = {
  getAll: () => axios.get(`${API}/projects`),
  create: (data) => apiClient.post('/admin/projects', data),
  update: (id, data) => apiClient.put(`/admin/projects/${id}`, data),
  delete: (id) => apiClient.delete(`/admin/projects/${id}`)
};

// Team APIs
export const teamAPI = {
  getAll: () => axios.get(`${API}/team`),
  create: (data) => apiClient.post('/admin/team', data),
  update: (id, data) => apiClient.put(`/admin/team/${id}`, data),
  delete: (id) => apiClient.delete(`/admin/team/${id}`)
};

// Partners/Customers APIs
export const partnersCustomersAPI = {
  getAll: (type = null) => {
    let url = `${API}/partners-customers`;
    if (type) url += `?type=${type}`;
    return axios.get(url);
  },
  create: (data) => apiClient.post('/admin/partners-customers', data),
  update: (id, data) => apiClient.put(`/admin/partners-customers/${id}`, data),
  delete: (id) => apiClient.delete(`/admin/partners-customers/${id}`)
};

// Testimonials APIs
export const testimonialsAPI = {
  getAll: () => axios.get(`${API}/testimonials`),
  create: (data) => apiClient.post('/admin/testimonials', data),
  update: (id, data) => apiClient.put(`/admin/testimonials/${id}`, data),
  delete: (id) => apiClient.delete(`/admin/testimonials/${id}`)
};

// Site Content APIs (flexible CMS)
export const contentAPI = {
  get: (section) => axios.get(`${API}/content/${section}`),
  getAdmin: (section) => apiClient.get(`/admin/content/${section}`),
  update: (section, data) => apiClient.put(`/admin/content/${section}`, data)
};

// LinkedIn Posts APIs
export const linkedinPostsAPI = {
  getAll: () => axios.get(`${API}/linkedin-posts`),
  create: (data) => apiClient.post('/admin/linkedin-posts', data),
  update: (id, data) => apiClient.put(`/admin/linkedin-posts/${id}`, data),
  delete: (id) => apiClient.delete(`/admin/linkedin-posts/${id}`)
};

export default apiClient;
